<template>
  <div style="padding-bottom: 120px;">
    <!-- <van-nav-bar
      :title="detail.enterpriseName"
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
      @click-right="onClickRight">
      <template #right>
        <van-icon name="gengduo1" size="28"/>
      </template>
    </van-nav-bar> -->
    <div class="detail-cont">
      <div class="job-header company-header">
        <div class="company-info">
          <img v-if="detail.enterpriseLogoUrl" :src="detail.enterpriseLogoUrl"/>
          <img v-else src="../../../../assets/img/logo2.png"/>
          <div class="company-inner">
            <h2>{{detail.enterpriseName}}</h2>
            <div class="about"><span>{{detail.enterpriseTypeName}}·{{detail.personnelSize}}·{{detail.enterpriseTradesName}}</span>
              <button @click="star">{{starStatus==true?"取消关注":"关注"}}</button>
            </div>
          </div>
        </div>
        <ul class="condition">
          <li>
            <van-icon name="shijian"></van-icon>
            <span>{{detail.workTimeStart}}-{{detail.workTimeEnd}}</span>
          </li>
          <li>
            <van-icon name="shijian"></van-icon>
            <span>{{detail.restType | getLabelName("REST_TYPE")}}</span>
          </li>
          <li>
            <van-icon name="xueli"></van-icon>
            <span>{{detail.overtimeType | getLabelName("OVERTIME_TYPE")}}</span>
          </li>
        </ul>
        <div class="title-02">
          <h3>企业福利</h3>
          <span class="icon-more" @click="showMore"
                style="z-index: 10"
                v-if="detail.positionLableList && detail.positionLableList.length > 4"
                :class="{'active':active}">{{brandFold?'查看全部':'收起'}}</span>
        </div>
        <ul class="welfare">
          <li v-for="item in showMoreList" :key="item.index">{{item.name}}</li>
        </ul>
      </div>
      <div class="company-tab">
        <ul class="edit-icon">
          <li @click="onShare">
            <van-icon name="fenxiang"></van-icon>
          </li>
          <li  @click="reportClick">
            <van-icon name="jubao"></van-icon>
          </li>
          <li @click="beforeShieldCompany" :class="{'text-blue':shield,'':!shield}">
            <van-icon name="eye-close"></van-icon>
          </li>
        </ul>
        <van-tabs title-inactive-color="#A3A7AD" title-active-color="#1C54CF" v-model="activeTab">
          <van-tab title="公司信息">
            <!--公司信息-->

            <div class="title-01" v-if="videoShow">
              <h2>公司视频</h2>
            </div>
            <!-- <video-player class="video-player vjs-custom-skin" v-if="videoShow"
                          ref="videoPlayer"
                          :playsinline="true"
                          :options="playerOptions"
            ></video-player> -->
            <video v-if="videoShow" id="videobox" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" controls preload="auto" webkit-playsinline="true" playsinline="true" type="application/x-mpegURL" allowsInlineMediaPlayback=YES  webview.allowsInlineMediaPlayback=YES  width='100%' ref='videoRef' x5-video-player-fullscreen="true"  >
                <source id="sourceBox" :src="videoUrl">
                <source :src="videoUrl" type="video/mp4">
                <source :src="videoUrl" type="video/ogg">
                <p class="vjs-no-js">不支持播放</p>
            </video>
            <div class="title-01" v-show="photoShow">
              <h2>公司环境</h2>
            </div>
            <ul class="photo-list" v-show="photoShow">
              <li v-for="item in photos" :key="item.index"><img :src="item"/></li>
            </ul>
            <div class="line"></div>
            <div class="title-01">
              <h2>公司简介</h2>
            </div>
            <div class="intr">
              {{showMoreDescription}}
              <span @click="showAll" style="color:rgb(81,141,219);"
              v-if="detail.enterpriseDescription && detail.enterpriseDescription.length>200"> {{showAllDescription?'查看全部':'收起'}}
        </span>
            </div>
            <div class="line"></div>
            <div class="title-01">
              <h2>公司地址</h2>
            </div>
            <div class="map">
              <div class="location">
                <van-icon name="weizhi"></van-icon>
                <span>{{detail.enterpriseAreaName}}{{detail.enterpriseAddress}}</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="在招职位">
            <ul class="job-list" v-if="detail.positionList" style="margin-top: 20px;">
              <li v-for="item in detail.positionList" :key="item.index" @click="jobDetail(item.id)">
                <div class="detail-info">
                  <div class="info-header">
                    <h3>{{item.jobName}}
                      <small v-if="item.urgent==1">急</small>
                    </h3>
                    <span>{{item.salary}}</span>
                  </div>
                  <ul class="conditionList">
                    <li>
                      {{item.expLevel}}
                    </li>
                    <li>
                      {{item.eduLevel}}
                    </li>
                  </ul>
                  <ul class="feature">
                    <li>
                      {{item.enterpriseName}}
                    </li>
                    <li>
                      {{item.personnelSize}}
                    </li>
                  </ul>
                  <div class="contact">
                    <div class="person">
                      <img v-if="item.recruitersAvatar" :src='item.recruitersAvatar'>
                      <img v-else src='../../../../assets/img/avatar_user.png'>
                      <span>{{item.recruitersName}}</span>
                      <span> ·{{item.recruitersJobTitle}}</span>
                    </div>
                    <div class="place">
                      {{item.jobArea}}
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <!--上拉在招职位-->
    <!--<transition name="fade">-->
      <!--<div class="fixed-company-detail" :style="{ top: top + 'px' }" :class="{'active':poptop}">-->
        <!--&lt;!&ndash;<button class="more-job" @click="toggleMoreJob"></button>&ndash;&gt;-->

        <!--<v-touch v-on:panmove="panmove" v-on:panend="panend" v-on:panstart="panstart" >-->
          <!--<button class="more-job  swiper-wrapper" @click=""></button>-->
        <!--</v-touch>-->
        <!--<h3>在招职位-->
          <!--<small>({{detail.positionList?detail.positionList.length:0}})</small>-->
        <!--</h3>-->

      <!--</div>-->
    <!--</transition>-->
    <van-share-sheet
      v-model="showShare"
      title="我要分享"
      :options="options"
      @select="onReport"
    />
    <!--弹出举报-->
    <transition name="fade">
      <div class="filter-cont report" v-show="reportPop">
        <div class="pop-header">
          <van-icon name="closed" @click="hiddenReportPop"></van-icon>
          <h2>举报</h2>
        </div>
        <h3>举报理由 </h3>
        <ul class="filter-list">
          <li v-for="(item,index) in reasonList" :key="item.index" :class="{checked:item.dictKey==form.reportReason}"
              @click="selectReason(item.dictKey)"><span>{{item.dictValue}}</span></li>
        </ul>
        <h3>举报说明 </h3>
        <textarea class="textarea" v-model="form.reportDescription" placeholder="请输入您的反馈，我们将不断为您改进，一经核实
将尽快联系您～" name="" id="" cols="30" rows="10">

        </textarea>
        <van-uploader v-model="fileList" :after-read="afterRead" :delete="deleteFile" :max-count="1">
        </van-uploader>
        <div class="fixed-bottom">
          <van-button type="primary" class="btn-blue" color="linear-gradient(to right top, #2F72F6,#1C54CF)"
                      @click="submitReport" round>提 交
          </van-button>
        </div>
      </div>
    </transition>
    <create-resume-dialog ref="resumeDialog"></create-resume-dialog>
  </div>
</template>

<script>
import { CONSTANT } from '../../../../utils/constant/data'
import configParam from '../../../../utils/constant'
import moment from "moment"
import Vue from "vue";
import createResumeDialog from '../components/createResumeDialog'
import native from '@utils/native'
import { throttle } from "@utils/index";

let pageHight= 0;
export default {
  name: 'companyDetail',
  components: { createResumeDialog },

  filters: {
    getLabelName: function (value, type) {
      let name = ''
      if (!value || value == -1) {
        return name
      }
      name = CONSTANT[type][value]
      return name
    }
  },
  data() {
    return {
      shield:false,
      activeTab:0,
      differ:0,
      top:0,
      startMove:0,
      detail: {},
      brandFold: true,
      showAllDescription: true,
      active: true,
      more: '',
      poptop: false,
      filterPop: false,
      form: {
        reportReason: '',
        reportType: CONSTANT.REPORT_TYPE.COMPANY,
        reportEnterpriseId: this.$route.query.id,
        reportDescription: '',
        tenantId: configParam.tenant('jiading'),
        reportEvidenceUrl: ''
      },
      reportPop: false,
      showShare: false,
      fileList: [],
      // 企业关注状态
      starStatus: false,
      options: [
        [
          { name: '微信', icon: require('../../../../assets/img/share/wechat.png') },
          { name: '朋友圈', icon: require('../../../../assets/img/share/pyq.png') },
          { name: 'QQ', icon: require('../../../../assets/img/share/qq.png') },
          { name: '微博', icon: require('../../../../assets/img/share/weibo.png') }
        ],
        [
          { name: '我要举报', icon: require('../../../../assets/img/share/jubao.png') },
          { name: '屏蔽公司', icon: require('../../../../assets/img/share/pingbi.png') }
        ]
      ],
      photos: [],
      reasonList: [],
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        // poster: '@/assets/img/newera/vlg.png', // 你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      },
      videoUrl:'',
      videoShow: false,
      photoShow: false
    }
  },

  computed: {
    showMoreList: {
      get: function () {
        if (this.brandFold) {
          if(!this.detail|| !this.detail.positionLableList){
            return "";
          }
          if (this.detail.positionLableList.length < 4) {
            return this.detail.positionLableList
          }
          let newList = []
          for (var i = 0; i < 4; i++) {
            let item = this.detail.positionLableList[i]
            newList.push(item)
          }
          return newList
        }
        return this.detail.positionLableList
      },
      set: function (val) {
        this.showMoreList = val
      }
    },

    showMoreDescription: {
      get: function () {
        if (this.showAllDescription) {
          if(!this.detail.enterpriseDescription){
            return "";
          }
          if (this.detail.enterpriseDescription.length <= 200) {
            return this.detail.enterpriseDescription
          } else {
            return this.detail.enterpriseDescription.substring(0, 200)
          }
        }
        return this.detail.enterpriseDescription
      },
      set: function (val) {
        this.showMoreList = val
      }
    }
  },
  methods: {
    panend(e){
      let needChange= pageHight*0.3;
      if(this.startMove>e.center.y){

        if(e.center.y-this.startMove>needChange){
          this.poptop=false
          this.top=pageHight*0.85
        }else{
          this.poptop=true
        }
      }else{
        if(e.center.y-this.startMove>needChange){

          this.poptop=false
          this.top=pageHight*0.85
        }else{
          this.poptop=true
        }

      }
    },
    panstart(e){

      this.startMove=0;
      this.differ=0;
      this.top=0;
      if(this.poptop){
        this.poptop=false;
        this.differ= Math.abs(60- e.center.y)
      }else{
        this.differ= pageHight*0.85- e.center.y
      }

      this.startMove=e.center.y;
    },
    panmove(e){
      this.top=this.differ+e.center.y;
    },
    // 关注企业
    star: throttle(function(){
      let that = this
      let rtnVal = native.shmedia2.isRmtNative()
      if (rtnVal === 40) {
        // 由于延时未调用查询简历接口
        this.module.api.hasResume({
          params: {},
          success: data => {
            console.log(data)
            this.$cookie.set('hasResume', data)
            if (data === true) {
              // 已登录已创建简历
              this.entStar();
            } else {
              // 登录了没有创建简历的情况
              this.$refs.resumeDialog.isShowDia()
            }
          }
        })
      } else if (rtnVal === 10) {
        // 已登录已创建简历
        this.entStar();
      } else if (rtnVal === 0) {
        // 端外
        window.AppSiteConfig.showDownDialog()
      } else if (rtnVal === 20) {
        // 登录了没有创建简历的情况
        this.$refs.resumeDialog.isShowDia()
      }
    },1000) ,
    entStar(){
      let that =this;
      this.module.api.entStar({
        params: {
          wdJobEnterpriseId: this.detail.id
        },
        success: (res) => {
          that.entStarStatus()
          this.toast('操作成功')
        }
      })
    },
    selectReason(value) {
      this.form.reportReason = value
    },
    /**
     * 调起举报
     */
    reportClick:throttle(function(){
      native.shmedia2.goToLoginFormTheApp(()=>{
        let token = this.$cookie.get("token")
        if(token){
          this.reportPop = true
        }
      })
    },1000),
    /**
       * 提交举报
       */
    submitReport() {
      this.module.api.report({
        params: this.form,
        success: (records) => {
          this.reportPop = false
          this.toast('举报成功')
        }
      })
    },
    /**
       * 加载举报原因
       */
    loadReportType() {
      this.module.api.bizDict({
        params: { code: 'report_reason_type' },
        success: (records) => {
          this.reasonList = records
        }
      })
    },

    entStarStatus() {
      if (this.$cookie.get('token')) {
        this.module.api.entStarStatus({
          params: {
            wdJobEnterpriseId: this.$route.query.id
          },
          success: (res) => {
            this.starStatus = res
          }
        })
      }
    },
    blockStatus() {
      if (this.$cookie.get('token')) {
        this.module.api.blockStatus({
          params: {
            wdJobEnterpriseId: this.$route.query.id
          },
          success: (res) => {
            this.shield = res
          }
        })
      }
    },

    deleteFile() {
      this.form.reportEvidenceUrl = ''
    },
    onload(wdJobEnterpriseId) {
      this.module.api.entDetail({
        params: { wdJobEnterpriseId },
        success: (res) => {
          this.detail = res
          if (res.entFileList) {
            for (let i = 0; i < res.entFileList.length; i++) {
              if (res.entFileList[i].fileType == 1) {
                this.videoShow = true
                // this.playerOptions.sources[0].src = res.entFileList[i].fileUrl
                // this.playerOptions.sources.push({
                //   type: '', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                //   src: res.entFileList[i].fileUrl // url地址
                // })
                this.videoUrl = res.entFileList[i].fileUrl
                setTimeout(()=>{
                  this.loadVideoConfig()
                },250)

              } else {
                this.photoShow = true
                this.photos.push(res.entFileList[i].fileUrl)
              }
            }
          }
        }
      })
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    onShare() {
      // this.showShare = true

      rmt.configUI({
        moreBox: {
          wechat: 'enable',       //"分享到微信"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          wechatMoment: 'enable', //"分享到朋友圈"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          qq: 'enable',           //"分享到QQ"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          qqZone: 'enable',       //"分享到QQ空间"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          weibo: 'enable',        //"分享到微博"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          theme: 'enable',        //"字体"与"配色"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          report: 'dismiss',       //"举报"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
          copyLink: 'enable'      //"拷贝链接"按钮。dismiss:不显示；disable：显示不可操作；enable：显示且可操作。
        },
      })


      //标题
      let title = this.detail.enterpriseName
      //简介
      let summary = this.showMoreDescription
      //链接地址
      let link = window.location.href
      //配图
      let imageUrl = this.detail.enterpriseLogoUrl || "//"+document.location.host + "/jdjob/image/logo2.png"

      rmt.configShare({
        //设置"分享到微信"数据
        wechat: {
          title,
          summary,
          link,
          imageUrl
        },
        //设置"分享到朋友圈"数据
        wechatMoment: {
          title,
          summary,
          link,
          imageUrl
        },
        //设置"分享到QQ"数据
        qq: {
          title,
          summary,
          link,
          imageUrl
        },
        //设置"分享到QQ空间"数据
        qqZone: {
          title,
          summary,
          link,
          imageUrl
        },
        //设置"分享到微博"数据
        weibo: {
          title,
          summary,
          link,
          imageUrl
        }
      });


      rmt.openMoreBox({
          wechat: 'enable',
          wechatMoment: 'enable',
          qq: 'enable',
          qqZone: 'enable',
          weibo: 'enable',
          theme: 'enable',  //字体/配色
          report: 'dismiss',
          copyLink: 'enable',
      });


    },
    toggleClass() {
      this.active = !this.active
    },
    showMore() {
      this.brandFold = !this.brandFold
      this.active = !this.active
    },
    showAll() {
      this.showAllDescription = !this.showAllDescription
    },
    hiddenReportPop() {
      this.reportPop = false
    },
    onReport(e) {
      if (e.name == '屏蔽公司' || e.name == '取消屏蔽') {
        this.beforeShieldCompany()
        // this.shieldCompany()
      } else if (e.name == '我要举报') {
        this.reportPop = true
        this.showShare = false
      }
    },
    toggleMoreJob() {
      this.poptop = !this.poptop
    },

    beforeShieldCompany:throttle(function(){

        let that = this
        let rtnVal = native.shmedia2.isRmtNative()
        if (rtnVal === 40) {
          // 由于延时未调用查询简历接口
          this.module.api.hasResume({
            params: {},
            success: data => {
              console.log(data)
              this.$cookie.set('hasResume', data)
              if (data === true) {
                // 已登录已创建简历
                this.shieldCompany();
              } else {
                // 登录了没有创建简历的情况
                this.$refs.resumeDialog.isShowDia()
              }
            }
          })
        } else if (rtnVal === 10) {
          // 已登录已创建简历
          this.shieldCompany();
        } else if (rtnVal === 0) {
          // 端外
          window.AppSiteConfig.showDownDialog()
        } else if (rtnVal === 20) {
          // 登录了没有创建简历的情况
          this.$refs.resumeDialog.isShowDia()
        }
    },1000),
    /**
       * 屏蔽公司
       */
    shieldCompany() {
      let wdJobEnterpriseId = this.$route.query.id
      this.module.api.entShield({
        params: {
          wdJobEnterpriseId: wdJobEnterpriseId
        },
        success: (res) => {
          if (res) {
            this.blockStatus();
            this.toast('操作成功')
          }
        }
      })
    },
    jobDetail(id) {
      this.$router.push({ path: 'jobDetail', query: { id } })
    },

    showFilterPop() {
      this.filterPop = true
    },
    // 上传文件
    afterRead(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      this.module.api.putFile({
        data: formData,
        success: (res) => {
          this.form.reportEvidenceUrl = res.link
        }
      })
    },
    loadVideoConfig(){
      //为避免在初始化video时播放源是空的，报播放源错误，需要先给source 的src赋值
      var player = videojs('videobox',{
                    bigPlayButton: true,
                    textTrackDisplay: true,
                    posterImage: true,
                    errorDisplay: false,
                    controlBar: false,
                    playbackRates: [0.5, 1, 1.5, 2],
                    ControlBar:{
                      customControlSpacer: true
                    }
                  },
                  function onPlayerReady(){
                    this.play();
                    setTimeout(() => {   //延时确保能监听到视频源错误
                        var mediaError = this.error();
                        if(mediaError!=null && mediaError.code){
                            _this.isError=true
                            Dialog.alert({
                                message: '啊哦，播放出错了。<br>请刷新重试，如无法播放建议您观看其它内容。',
                                confirmButtonText:'确定'
                            }).then(() => {
                                _this.goback();
                            });
                        }
                    },1000);
                  }
                );
      // 删除全屏按钮
      document.querySelector("button.vjs-fullscreen-control").remove()
      // 创建自定义全屏按钮
      let doc = document.querySelector(".vjs-control-bar")

      let button = document.createElement("button")
      button.setAttribute("class","vjs-fullscreen-control vjs-control vjs-button")
      button.setAttribute("type","button")
      button.setAttribute("title","Fullscreen")
      button.setAttribute("aria-disabled","false")

      let span1 = document.createElement("span")
      span1.setAttribute("aria-hidden","true")
      span1.setAttribute("class","vjs-icon-placeholder")

      let span2 = document.createElement("span")
      span2.setAttribute("aria-live","polite")
      span2.setAttribute("class","vjs-control-text")
      span2.innerText = "Fullscreen"

      button.appendChild(span1)
      button.appendChild(span2)

      // 添加自定义全屏 单击事件
      button.onclick = ()=>{
        let timestamp = moment.duration(player.currentTime(), "seconds").asMilliseconds() // 当前播放毫秒
        //console.log(this.videoUrl)

        // 桥接全屏
        rmt.openVideoPlayer({
          video: {
            sourceUrl:this.videoUrl,//视频地址
          },
          autoStart: true,//是否自动播放,
          timestamp, //开始时间戳：毫秒
        });
      }

      doc.appendChild(button)

      // player.width(this.videoW)   //设置播放器宽度

    }
  },

  mounted() {
    // pageHight=document.documentElement.clientHeight;
    // this.top=pageHight*0.85;
    this.onload(this.$route.query.id)
    this.entStarStatus()
    this.blockStatus();
    this.loadReportType()
  },
  created(){

  },
  beforeDestroy(){
    const videoDom = this.$refs.videoRef;   //不能用document 获取节点
    if(videoDom){
      videojs(videoDom).dispose();  //销毁video实例，避免出现节点不存在 但是flash一直在执行,也避免重新进入页面video未重新声明
    }
    
  }
}
</script>

<style lang="less" scoped>
  .text-blue{
    i:before{
      color:#1C54CF;
      content: '\e6dc';
    }
  }
  .company-tab{
    position: relative;
    /deep/.van-tabs__wrap{
      justify-content: flex-start;
      box-shadow: 0 10px 10px rgba(51,86,161,.06);
      height: 50px;
      .van-tab__text{
        font-size: 18px;
        padding:10px 16px;
      }
      .van-tab{
        flex:inherit;
      }
      .van-tabs__line{
        background:#1C54CF;
        width: 16px;
      }
    }
    .edit-icon{
      position: absolute;
      right:10px;
      top:0;
      z-index: 999;
      margin-top: 10px;
      li {
        margin:0 5px;
        i{
          font-size: 22px;
        }
        &:after {
          display: none;
        }
      }
    }
  }
  .title-01{
    margin-top: 30px;
  }
  /deep/ .van-nav-bar {
    background: #1C54CF;

    .van-nav-bar__title, i {
      color: #fff;
      font-weight: normal;
    }
  }

  /deep/ .van-share-sheet__title {
    font-size: 14px;
    color: #ADB0B6;
  }

  /deep/ .van-share-sheet__options {
    .van-share-sheet__option {
      width: 25%;
    }

    .van-share-sheet__icon {
      width: auto;
      height: 30px;
    }
  }

  /deep/ .van-uploader {
    margin: 10px 16px;

    .van-uploader__preview-delete-icon {
      top: -3px;
    }
  }

  /deep/ .video-player {
    margin: 10px 16px;
    border-radius: 10px;
  }

  /deep/ .video-js.vjs-fluid, /deep/ .vjs-poster, /deep/ .video-js.vjs-16-9, /deep/ .video-js.vjs-4-3, /deep/ .video-js .vjs-tech {
    border-radius: 8px;
  }

  .textarea {
    width: 100%;
    min-height: 170px;
    background: #F8F9FB;
    border-radius: 4px;
    border: none;
    margin: 2px 16px;
    padding: 16px;
    font-size: 14px;

    &::-webkit-input-placeholder {
      color: #ccc
    }
  }

  .fixed-bottom {
    padding: 10px 16px 20px;

    button {
      flex: 1;
    }
  }

  .job-list {
    margin-left: 0;
    margin-right: 0;

    & > li {
      padding: 6px 16px;
      border-bottom: 8px solid #F7F7F7;

      &:last-child {
        border-bottom: 0;
      }
    }
  }

  /deep/ .van-popup {
    border-radius: 0;
  }

</style>
